module.exports = __webpack_public_path__ + "2fae7ac113a9608d9db31006250b7539.MP3";